function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_12",
  "data-name": "Ellipse 12",
  cx: 21,
  cy: 21,
  r: 21,
  fill: "#eeeff3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_243",
  "data-name": "Group 243",
  transform: "translate(11 10)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_237",
  "data-name": "Group 237",
  transform: "translate(2 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_236",
  "data-name": "Group 236",
  transform: "translate(4)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M-2056.259,6.506h-2.13v-.3a1.686,1.686,0,0,0-1.68-1.69h-.04a1.686,1.686,0,0,0-1.68,1.69v.3h-2.13a.2.2,0,0,0-.2.2V8.857a.2.2,0,0,0,.2.2h7.66a.2.2,0,0,0,.2-.2V6.706A.2.2,0,0,0-2056.259,6.506Zm-3.83-1.32a.559.559,0,0,1,.561.56.559.559,0,0,1-.561.56.559.559,0,0,1-.56-.56A.559.559,0,0,1-2060.089,5.186Z",
  transform: "translate(2064.119 -4.516)",
  fill: "#00cd98"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M-2053.859,8.076h-.99V9.357a.986.986,0,0,1-.99.989h-8.5a.986.986,0,0,1-.99-.989V8.076h-1.02a1.767,1.767,0,0,0-1.77,1.77v12.48a1.767,1.767,0,0,0,1.77,1.77h12.49a1.765,1.765,0,0,0,1.76-1.77V9.846A1.765,1.765,0,0,0-2053.859,8.076Zm-11.669,5.52h6.829a.892.892,0,0,1,.89.89.893.893,0,0,1-.89.891h-6.829a.9.9,0,0,1-.9-.891A.9.9,0,0,1-2065.528,13.6Zm10.889,5.781h-10.889a.9.9,0,0,1-.9-.891.9.9,0,0,1,.9-.89h10.889a.892.892,0,0,1,.89.89A.893.893,0,0,1-2054.639,19.377Z",
  transform: "translate(2068.119 -4.516)",
  fill: "#00cd98"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_116",
  "data-name": "Rectangle 116",
  width: 20,
  height: 20,
  fill: "none"
}));

var SvgExamInsideCircle = function SvgExamInsideCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_434",
    "data-name": "Group 434",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExamInsideCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exam-inside-circle.65244d91.svg";
export { ForwardRef as ReactComponent };